<script lang="ts" setup>
  import { useTitropEvents } from '@/composables/useTitropEvents.ts'
  import CheckboxTitrop from '@/elements/CheckboxTitrop.vue'
  import { getKnownLoggers, getLogger, Logger, LogLevel } from '@/composables/useLogger'

  const visible = useSessionStorage('developer_dialog_open', false, { listenToStorageChanges: true, writeDefaults: false })
  useTitropEvents().hotkeyToggleDeveloperDialog.on(() => {
    visible.value = !visible.value
  })

  async function reloadLoggers() {
    return new Promise((resolve) => {
      loggers.value = getKnownLoggers()
        .map(getLogger)
        .filter((s) => !!s) as Logger[]
      resolve(undefined)
    })
  }

  const loggers = ref<Logger[]>()
  const logLevels: string[] = Object.values(LogLevel)

  const showLoggerSettings = ref(false)
  watch(showLoggerSettings, (newVal, _oldVal) => {
    loggers.value = undefined
    if (newVal) {
      void reloadLoggers()
    }
  })
</script>

<template>
  <Dialog
    id="developer_dialog"
    v-model:visible="visible"
    :modal="false"
    :block-scroll="false"
    :close-on-escape="false"
    :dismissable-mask="false"
    class="bg-blue-200 dark:bg-gray-800 border border-gray-400 text-sm"
    header="Entwickeroptionen"
    position="right">
    <div class="flex flex-col gap-y-2 w-full">
      <div class="flex gap-x-1 flex-row-reverse">
        <label class="flex-1">DevDumps zeigen</label>
        <CheckboxTitrop
          v-model="$titrop.enableDevDumps"
          :binary="true" />
      </div>
      <div class="flex gap-x-1 flex-row-reverse">
        <label class="flex-1">Erweiterte Ansicht</label>
        <CheckboxTitrop
          v-model="$titrop.extendedView"
          :binary="true" />
      </div>
      <div class="flex gap-x-1 flex-row-reverse">
        <label class="flex-1">Titrop-Ids zeigen</label>
        <CheckboxTitrop
          v-model="$titrop.showIds"
          :binary="true" />
      </div>
      <div
        v-if="$titrop.DEV"
        class="flex gap-x-1 flex-row-reverse">
        <label class="flex-1">View-Namen zeigen</label>
        <CheckboxTitrop
          v-model="$titrop.showViewComponents"
          :binary="true" />
      </div>

      <div>
        <div class="flex gap-x-1 flex-row-reverse">
          <label class="flex-1">Logger-Settings anzeigen</label>
          <CheckboxTitrop
            v-model="showLoggerSettings"
            binary />
        </div>
        <DataTable
          v-if="showLoggerSettings"
          :value="loggers"
          data-key="name"
          size="small">
          <Column
            field="name"
            header="Logger" />

          <Column
            v-for="level in logLevels"
            :key="level"
            :header="level.toUpperCase()">
            <template #body="slotProps">
              <Checkbox
                :value="slotProps.data.levels[level]"
                binary
                @value-change="(value) => slotProps.data.setLevel(level, value)" />
            </template>
          </Column>
        </DataTable>
      </div>
    </div>
  </Dialog>
</template>
<style>
  #developer_dialog_header san.p-dialog-title {
    font-size: 0.875rem !important;
    line-height: 1.25rem !important;
  }
</style>
